import { useEffect } from "react";
import AppLoading from '../components/AppLoading';
import { BillingRouter, PrivateAppRouter, PublicAppRouter } from '../routers/AppRouter'
import { useUser } from '../contexts/user.context';
import { useOnboarding } from "../contexts/onboarding.context";
import useAuthentication from '../hooks/authentication.hook';
import { storeStatus } from '../utils/constants';

export default function AppAuthentication() {
    const { isAuthLoading } = useAuthentication()
    const { user } = useUser()
    const { setData } = useOnboarding();

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)

        const allowsIframe = searchParams.get("iframe")
        const platformId = searchParams.get("platform_id")
        const platformName = searchParams.get("platform_name")
        const storeId = searchParams.get("store_id")
        const storeName = searchParams.get("store_name")
        const storeUrl = searchParams.get("store_url")
        const platformToken = searchParams.get("platform_token")

        if (storeId && storeUrl && platformId && platformToken) {
            const onboardingData = {
                ecommercePlatformAllowsIframe: allowsIframe === '1',
                ecommercePlatformId: platformId,
                ecommercePlatformName: platformName,
                ecommercePlatformToken: platformToken,
                storeId: storeId,
                storeName: storeName,
                storeUrl: storeUrl,
            }

            setData(onboardingData)
        }
    }, [])

    if (isAuthLoading)
        return <AppLoading />

    if (!user)
        return <PublicAppRouter />

    // // If the onboarding is completed, allow the panel to load only 
    // // if the store status is on_trial or active
    // if (
    //     user?.isOnboardingCompleted &&
    //     user?.store &&
    //     ![storeStatus.ON_TRIAL, storeStatus.ACTIVE].includes(user?.store?.status)
    // ) {
    //     return <BillingRouter />
    // }

    return <PrivateAppRouter />
}